import React, { useRef, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { handleChangeDataModalAddAddress } from '../../../../redux/actions/partials/modals/modalAddAddress';
import { handleChangeDataModalAddCustomAddress } from '../../../../redux/actions/partials/modals/modalAddCustomAddress';
import { handleChangeProfileData } from "../../../../redux/actions/pages/user/user";
import { USERS_EDIT_EMAIL } from '../../../../apis';
import useOutsideClick from './hooks/useOutsideClick'; 
import apiRequest from '../../../../utils/apiRequest';
import LeafletMap from "../map/LeafletMap";
import { Marker } from 'react-leaflet';
import L from 'leaflet';
import ICON from '../../../../styles/images/svg/location-marker.svg';


const ModalAddAddress = (props) => {

	const dispatch = useDispatch();

	const { isMobile } = useSelector(state => state.general);
	const { isActive, glat, glng } = useSelector(state => state.modalAddAddress);
	const { token, profile } = useSelector(state => state.login);
	const { isBackdropLoading } = useSelector(state => state.allLoaders);


	const handleClose = () => {
		dispatch(handleChangeDataModalAddAddress('isActive', false))
		setTimeout(() => {
            dispatch(handleChangeDataModalAddAddress('isOpen', false));
        }, 250);
    };    


    const outerRef = useRef(null);
  	const centerBoxRef = useRef(null);
  	useOutsideClick(outerRef, centerBoxRef, handleClose, [ModalAddAddress]);


    const handleChangeInputs = (event) => {
    	const {name, value} = event.target;
    	dispatch(handleChangeDataModalAddAddress(name, value));
    };

	// const inputRefs = useRef({});
	// const handleOnInputFocus = (key) => {
 //        const currentInput = inputRefs.current[key];
 //        if (currentInput && errorTxt.length === 0) {
 //            dispatch(handleChangeInputLoginPage('inputClass', 'input-focused'));
 //            currentInput.classList.add("input-focused");
 //        }
 //    };


 	const handleShowModalAddCustomAddress = () => {
 		dispatch(handleChangeDataModalAddCustomAddress('isOpen', true));
		setTimeout(() => dispatch(handleChangeDataModalAddCustomAddress('isActive', true)), 0);

		handleClose();
 	};


    return (

		<div ref={outerRef} className={`ReactModal__Overlay ${isActive ? 'ReactModal__Overlay--after-open' : ''}`} style={{position: 'fixed', inset: '0px', backgroundColor: 'rgba(0, 0, 0, 0.3)', zIndex: '11'}}>
			<div ref={centerBoxRef} className="ReactModal__Content ReactModal__Content--after-open bg-neutral-000 absolute overflow-y-hidden rounded-medium styles_Modal__TsaRp" tabIndex="-1" role="dialog" aria-modal="true" style={ !isMobile ? {width: '780px'} : {width: '100%', maxHeight: '100vh', height: '100%'} }>
				<div className="flex flex-col h-full overflow-y-hidden styles_ModalLayout__y3Bs1" style={{paddingTop: '93px', paddingBottom: '80px'}}>
					<div className="w-full z-1 bg-neutral-000 fixed top-0 right-0 px-5" width="740" height="92.62">
						<div className="flex items-center border-complete-b-200 py-4">
							<div class="grow text-h5">
								<div>
									<div class="flex items-center justify-between">
										<div class="user-select-none">
											<div class="text-h5 text-neutral-900">انتخاب موقعیت مکانی
											</div>
											<div class="text-body-2 text-neutral-500">سفارش‌های شما به موقعیتی که انتخاب می‌کنید ارسال می‌شود. لطفاً موقعیت مکانی را دقیق انتخاب کنید تا از تأخیر در تحویل جلوگیری شود.
											</div>
										</div>
									</div>
								</div>
							</div>
							<div onClick={handleClose} class="flex cursor-pointer">
								<svg data-test-id="close-modal-icon-button" style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
									<use xlinkHref="#close"></use>
								</svg>
							</div>
						</div>
					</div>
					<div className="grow flex flex-col overflow-y-auto">
						<div className="grow flex flex-col styles_children__hHq5Q py-4 px-5">
							
							<div class="h-full overflow-auto">
								<div class="mb-4" style={{height: '300px'}}>
									
									<LeafletMap className="w-100" center={[glat, glng]} zoom={13} data={{type: 'ADD'}} >
					                    <Marker 
					                        position={[glat, glng]}
					                        icon={new L.Icon({iconUrl: ICON, iconAnchor: [20, 50], iconSize: [55, 55], className: 'leaflet-marker-icon'})} />
					                </LeafletMap>


								</div>
							</div>

						</div>
					</div>
					<div class="w-full z-1 bg-neutral-000 px-5 py-4 fixed bottom-0 right-0 shadow-1-top" width="740" height="48">
						<div>
							<div class="flex items-center justify-between user-select-none bg-neutral-000 ">
								{/*<button onClick={handleShowModalAddCustomAddress} class="relative flex items-center user-select-none styles_btn__Q4MvL text-button-1 styles_btn--large__1Muai styles_btn--outlined__saFC3 styles_btn--primary__y0GEv rounded-medium w-full">
									<div class="flex items-center justify-center relative grow">
										<span class="text-h5-regular"> ثبت دستی آدرس</span>
									</div>
								</button>*/}
								<button onClick={handleShowModalAddCustomAddress} class="relative flex items-center user-select-none styles_btn__Q4MvL text-button-1 styles_btn--large__1Muai styles_btn--primary__y0GEv rounded-medium whitespace-nowrap w-full mr-3">
									<div class="flex items-center justify-center relative grow">
										<span class="text-h5-regular">ثبت موقعیت مکانی</span>
									</div>
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>



        
    );
}

export default ModalAddAddress;
